<template>
  <div class="promo">
    <div class="promo__lottie">
      <lottie
        :options="defaultOptions"
        :height="120"
        :width="120"
      />
    </div>
    <div class="promo__header">
      <div class="promo__title">
        Уважаемый абонент!
      </div>
    </div>

    <div class="promo__text">
      Вам доступен <span class="highlight">пробный период</span> по услуге
      <b class="service-name">Видеоаналитика</b> — для повышения эффективности и безопасности Вашего бизнеса.
      <a class="service-link" target="_blank" href="https://business.ufanet.ru/smb/videoanalytics?utm_source=ucams&utm_medium=banner&utm_campaign=tryperiod">
        Подробнее на сайте
      </a>
    </div>

    <div class="promo__features" role="list">
      <div class="promo__feature" role="listitem">
        <div class="feature-icon">
          <svg
            width="19"
            height="14"
            viewBox="0 0 19 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0 11C0 10.5278 0.121528 10.0937 0.364583 9.69792C0.607639 9.30208 0.930556 9 1.33333 8.79167C2.19444 8.36111 3.06944 8.03819 3.95833 7.82292C4.84722 7.60764 5.75 7.5 6.66667 7.5C7.58333 7.5 8.48611 7.60764 9.375 7.82292C10.2639 8.03819 11.1389 8.36111 12 8.79167C12.4028 9 12.7257 9.30208 12.9688 9.69792C13.2118 10.0937 13.3333 10.5278 13.3333 11V11.6667C13.3333 12.125 13.1701 12.5174 12.8438 12.8437C12.5174 13.1701 12.125 13.3333 11.6667 13.3333H1.66667C1.20833 13.3333 0.815972 13.1701 0.489583 12.8437C0.163194 12.5174 0 12.125 0 11.6667V11ZM16.6667 13.3333H14.5417C14.6944 13.0833 14.809 12.816 14.8854 12.5312C14.9618 12.2465 15 11.9583 15 11.6667V10.8333C15 10.2222 14.8299 9.63542 14.4896 9.07292C14.1493 8.51042 13.6667 8.02778 13.0417 7.625C13.75 7.70833 14.4167 7.85069 15.0417 8.05208C15.6667 8.25347 16.25 8.5 16.7917 8.79167C17.2917 9.06944 17.6736 9.37847 17.9375 9.71875C18.2014 10.059 18.3333 10.4306 18.3333 10.8333V11.6667C18.3333 12.125 18.1701 12.5174 17.8438 12.8437C17.5174 13.1701 17.125 13.3333 16.6667 13.3333ZM6.66667 6.66667C5.75 6.66667 4.96528 6.34028 4.3125 5.6875C3.65972 5.03472 3.33333 4.25 3.33333 3.33333C3.33333 2.41667 3.65972 1.63194 4.3125 0.979167C4.96528 0.326389 5.75 0 6.66667 0C7.58333 0 8.36806 0.326389 9.02083 0.979167C9.67361 1.63194 10 2.41667 10 3.33333C10 4.25 9.67361 5.03472 9.02083 5.6875C8.36806 6.34028 7.58333 6.66667 6.66667 6.66667ZM15 3.33333C15 4.25 14.6736 5.03472 14.0208 5.6875C13.3681 6.34028 12.5833 6.66667 11.6667 6.66667C11.5139 6.66667 11.3194 6.64931 11.0833 6.61458C10.8472 6.57986 10.6528 6.54167 10.5 6.5C10.875 6.05556 11.1632 5.5625 11.3646 5.02083C11.566 4.47917 11.6667 3.91667 11.6667 3.33333C11.6667 2.75 11.566 2.1875 11.3646 1.64583C11.1632 1.10417 10.875 0.611111 10.5 0.166667C10.6944 0.0972222 10.8889 0.0520833 11.0833 0.03125C11.2778 0.0104167 11.4722 0 11.6667 0C12.5833 0 13.3681 0.326389 14.0208 0.979167C14.6736 1.63194 15 2.41667 15 3.33333ZM1.66667 11.6667H11.6667V11C11.6667 10.8472 11.6285 10.7083 11.5521 10.5833C11.4757 10.4583 11.375 10.3611 11.25 10.2917C10.5 9.91667 9.74306 9.63542 8.97917 9.44792C8.21528 9.26042 7.44444 9.16667 6.66667 9.16667C5.88889 9.16667 5.11806 9.26042 4.35417 9.44792C3.59028 9.63542 2.83333 9.91667 2.08333 10.2917C1.95833 10.3611 1.85764 10.4583 1.78125 10.5833C1.70486 10.7083 1.66667 10.8472 1.66667 11V11.6667ZM6.66667 5C7.125 5 7.51736 4.83681 7.84375 4.51042C8.17014 4.18403 8.33333 3.79167 8.33333 3.33333C8.33333 2.875 8.17014 2.48264 7.84375 2.15625C7.51736 1.82986 7.125 1.66667 6.66667 1.66667C6.20833 1.66667 5.81597 1.82986 5.48958 2.15625C5.16319 2.48264 5 2.875 5 3.33333C5 3.79167 5.16319 4.18403 5.48958 4.51042C5.81597 4.83681 6.20833 5 6.66667 5Z" fill="#2F84F8" />
          </svg>
        </div>
        <div class="feature-text">
          Распознавание очередей
        </div>
      </div>
      <div class="promo__feature" role="listitem">
        <div class="feature-icon">
          <svg
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M4.16667 7.5C3.93056 7.5 3.73264 7.57986 3.57292 7.73958C3.41319 7.89931 3.33333 8.09722 3.33333 8.33333V10.8333C3.33333 11.0694 3.41319 11.2674 3.57292 11.4271C3.73264 11.5868 3.93056 11.6667 4.16667 11.6667C4.40278 11.6667 4.60069 11.5868 4.76042 11.4271C4.92014 11.2674 5 11.0694 5 10.8333V8.33333C5 8.09722 4.92014 7.89931 4.76042 7.73958C4.60069 7.57986 4.40278 7.5 4.16667 7.5ZM10.8333 3.33333C10.5972 3.33333 10.3993 3.41319 10.2396 3.57292C10.0799 3.73264 10 3.93056 10 4.16667V10.8333C10 11.0694 10.0799 11.2674 10.2396 11.4271C10.3993 11.5868 10.5972 11.6667 10.8333 11.6667C11.0694 11.6667 11.2674 11.5868 11.4271 11.4271C11.5868 11.2674 11.6667 11.0694 11.6667 10.8333V4.16667C11.6667 3.93056 11.5868 3.73264 11.4271 3.57292C11.2674 3.41319 11.0694 3.33333 10.8333 3.33333ZM7.5 9.16667C7.26389 9.16667 7.06597 9.24653 6.90625 9.40625C6.74653 9.56597 6.66667 9.76389 6.66667 10V10.8333C6.66667 11.0694 6.74653 11.2674 6.90625 11.4271C7.06597 11.5868 7.26389 11.6667 7.5 11.6667C7.73611 11.6667 7.93403 11.5868 8.09375 11.4271C8.25347 11.2674 8.33333 11.0694 8.33333 10.8333V10C8.33333 9.76389 8.25347 9.56597 8.09375 9.40625C7.93403 9.24653 7.73611 9.16667 7.5 9.16667ZM1.66667 15C1.20833 15 0.815972 14.8368 0.489583 14.5104C0.163194 14.184 0 13.7917 0 13.3333V1.66667C0 1.20833 0.163194 0.815972 0.489583 0.489583C0.815972 0.163194 1.20833 0 1.66667 0H13.3333C13.7917 0 14.184 0.163194 14.5104 0.489583C14.8368 0.815972 15 1.20833 15 1.66667V13.3333C15 13.7917 14.8368 14.184 14.5104 14.5104C14.184 14.8368 13.7917 15 13.3333 15H1.66667ZM1.66667 13.3333H13.3333V1.66667H1.66667V13.3333ZM7.5 7.5C7.73611 7.5 7.93403 7.42014 8.09375 7.26042C8.25347 7.10069 8.33333 6.90278 8.33333 6.66667C8.33333 6.43056 8.25347 6.23264 8.09375 6.07292C7.93403 5.91319 7.73611 5.83333 7.5 5.83333C7.26389 5.83333 7.06597 5.91319 6.90625 6.07292C6.74653 6.23264 6.66667 6.43056 6.66667 6.66667C6.66667 6.90278 6.74653 7.10069 6.90625 7.26042C7.06597 7.42014 7.26389 7.5 7.5 7.5Z" fill="#2F84F8" />
          </svg>
        </div>
        <div class="feature-text">
          Подсчёт посетителей
        </div>
      </div>
      <div class="promo__feature" role="listitem">
        <div class="feature-icon">
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M2.5 16.6667C1.80556 16.6667 1.21528 16.4236 0.729167 15.9375C0.243056 15.4514 0 14.8611 0 14.1667C0 13.625 0.15625 13.1424 0.46875 12.7187C0.78125 12.2951 1.18056 11.9931 1.66667 11.8125V4.85417C1.18056 4.67361 0.78125 4.37153 0.46875 3.94792C0.15625 3.52431 0 3.04167 0 2.5C0 1.80556 0.243056 1.21528 0.729167 0.729167C1.21528 0.243056 1.80556 0 2.5 0C3.04167 0 3.52431 0.15625 3.94792 0.46875C4.37153 0.78125 4.67361 1.18056 4.85417 1.66667H11.8125C11.9792 1.18056 12.2743 0.78125 12.6979 0.46875C13.1215 0.15625 13.6111 0 14.1667 0C14.8611 0 15.4514 0.243056 15.9375 0.729167C16.4236 1.21528 16.6667 1.80556 16.6667 2.5C16.6667 3.05556 16.5104 3.54514 16.1979 3.96875C15.8854 4.39236 15.4861 4.6875 15 4.85417V11.8125C15.4861 11.9931 15.8854 12.2951 16.1979 12.7187C16.5104 13.1424 16.6667 13.625 16.6667 14.1667C16.6667 14.8611 16.4236 15.4514 15.9375 15.9375C15.4514 16.4236 14.8611 16.6667 14.1667 16.6667C13.625 16.6667 13.1424 16.5104 12.7187 16.1979C12.2951 15.8854 11.9931 15.4861 11.8125 15H4.85417C4.67361 15.4861 4.37153 15.8854 3.94792 16.1979C3.52431 16.5104 3.04167 16.6667 2.5 16.6667ZM2.5 3.33333C2.73611 3.33333 2.93403 3.25347 3.09375 3.09375C3.25347 2.93403 3.33333 2.73611 3.33333 2.5C3.33333 2.26389 3.25347 2.06597 3.09375 1.90625C2.93403 1.74653 2.73611 1.66667 2.5 1.66667C2.26389 1.66667 2.06597 1.74653 1.90625 1.90625C1.74653 2.06597 1.66667 2.26389 1.66667 2.5C1.66667 2.73611 1.74653 2.93403 1.90625 3.09375C2.06597 3.25347 2.26389 3.33333 2.5 3.33333ZM14.1667 3.33333C14.4028 3.33333 14.6007 3.25347 14.7604 3.09375C14.9201 2.93403 15 2.73611 15 2.5C15 2.26389 14.9201 2.06597 14.7604 1.90625C14.6007 1.74653 14.4028 1.66667 14.1667 1.66667C13.9306 1.66667 13.7326 1.74653 13.5729 1.90625C13.4132 2.06597 13.3333 2.26389 13.3333 2.5C13.3333 2.73611 13.4132 2.93403 13.5729 3.09375C13.7326 3.25347 13.9306 3.33333 14.1667 3.33333ZM4.85417 13.3333H11.8125C11.9375 12.9722 12.1319 12.6597 12.3958 12.3958C12.6597 12.1319 12.9722 11.9375 13.3333 11.8125V4.85417C12.9722 4.72917 12.6597 4.53472 12.3958 4.27083C12.1319 4.00694 11.9375 3.69444 11.8125 3.33333H4.85417C4.72917 3.69444 4.53472 4.00694 4.27083 4.27083C4.00694 4.53472 3.69444 4.72917 3.33333 4.85417V11.8125C3.69444 11.9375 4.00694 12.1319 4.27083 12.3958C4.53472 12.6597 4.72917 12.9722 4.85417 13.3333ZM14.1667 15C14.4028 15 14.6007 14.9201 14.7604 14.7604C14.9201 14.6007 15 14.4028 15 14.1667C15 13.9306 14.9201 13.7326 14.7604 13.5729C14.6007 13.4132 14.4028 13.3333 14.1667 13.3333C13.9306 13.3333 13.7326 13.4132 13.5729 13.5729C13.4132 13.7326 13.3333 13.9306 13.3333 14.1667C13.3333 14.4028 13.4132 14.6007 13.5729 14.7604C13.7326 14.9201 13.9306 15 14.1667 15ZM2.5 15C2.73611 15 2.93403 14.9201 3.09375 14.7604C3.25347 14.6007 3.33333 14.4028 3.33333 14.1667C3.33333 13.9306 3.25347 13.7326 3.09375 13.5729C2.93403 13.4132 2.73611 13.3333 2.5 13.3333C2.26389 13.3333 2.06597 13.4132 1.90625 13.5729C1.74653 13.7326 1.66667 13.9306 1.66667 14.1667C1.66667 14.4028 1.74653 14.6007 1.90625 14.7604C2.06597 14.9201 2.26389 15 2.5 15Z" fill="#2F84F8" />
          </svg>
        </div>
        <div class="feature-text">
          Контроль периметра
        </div>
      </div>
    </div>

    <div class="promo__footer">
      <a class="promo__cta">
        <div class="promo__cta-title">Узнать подробнее</div>

        <div class="promo__cta-phone">
          <span class="promo__cta-phone-icon" aria-hidden="true">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M3.62 7.79C5.06 10.62 7.38 12.93 10.21 14.38L12.41 12.18C12.68 11.91 13.08 11.82 13.43 11.94C14.55 12.31 15.76 12.51 17 12.51C17.55 12.51 18 12.96 18 13.51V17C18 17.55 17.55 18 17 18C7.61 18 0 10.39 0 1C0 0.45 0.45 0 1 0H4.5C5.05 0 5.5 0.45 5.5 1C5.5 2.25 5.7 3.45 6.07 4.57C6.18 4.92 6.1 5.31 5.82 5.59L3.62 7.79Z" fill="white" />
            </svg>
          </span>

          <span class="promo__cta-phone-number">09388</span>
        </div>
      </a>

      <div class="promo__footer-note">
        Бесплатный звонок Мегафон, Билайн, МТС, Yota, Т-Мобайл
      </div>
    </div>
  </div>
</template>

<script>
import {createEntityMixin} from "@/components/pacs/mixins.js";
import Lottie from 'vue-lottie';
import animationData from '/src/assets/promo.json';

export default {
  name: "VideoAnalyticsPromo",
  mixins: [createEntityMixin],
  components: {Lottie},
  data() {
    return {
      defaultOptions: {
        animationData,
        loop: false,
        autoplay: true,
      },
    };
  },
  props: {
    onClose: {
      type: Function,
      default: () => {}
    }
  },
};
</script>

<style scoped lang="scss">
.promo {
  width: 480px;
  max-width: calc(100vw - 32px);
  padding: 32px;
  border-radius: 20px;
  color: #1b1f2a;
  position: relative;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  animation: slideUp 0.4s ease;
}

.promo__header {
  text-align: center;
  margin-bottom: 24px;
}

.promo__icon {
  margin: 0 auto 16px;
  width: 64px;
  height: 64px;
  background: #2F84F8;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 32px;
    height: 32px;

    path {
      fill: white;
    }
  }
}

.promo__title {
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.2px;
  color: #1b1f2a;
  margin-top: -25px;
}

.promo__text {
  font-size: 15px;
  line-height: 1.6;
  text-align: center;
  margin-bottom: 28px;
}

.highlight {
  color: #2F84F8;
  font-weight: 600;
  background: rgba(31, 91, 255, 0.1);
  padding: 2px 6px;
  border-radius: 4px;
}

.service-name {
  color: #2F84F8;
  font-weight: 700;
}
.service-link {
  color: #2F84F8;
  text-decoration: underline;
}

.promo__features {
  background: white;
  border-radius: 16px;
  padding: 10px;
  margin: 24px 0;
  border: 1px solid rgba(31, 91, 255, 0.1);
  box-shadow: 0 4px 12px rgba(31, 91, 255, 0.05);
}

.promo__feature {
  display: flex;
  align-items: center;
  padding: 12px 0;
  font-size: 15px;
  color: #2d3748;
  margin-left: 60px;
  margin-right: 60px;
  &:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }
}

.feature-icon {
  font-size: 20px;
  margin-right: 16px;
  width: 32px;
  text-align: center;
}

.feature-text {
  flex: 1;
  font-weight: 500;
}

.promo__footer {
  margin-top: 24px;
  padding: 0 30px 0 30px;
}

.promo__cta {
  width: 100%;
  height: 74px;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  text-decoration: none;
  color: #fff;
  background: #2F84F8;
  box-shadow: 0 14px 28px rgba(47, 132, 248, 0.22);
  position: relative;
  overflow: hidden;
}

.promo__cta-title {
  position: relative;
  font-size: 14px;
  line-height: 1;
  opacity: 0.95;
}

.promo__cta-phone {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 500;
  line-height: 1;
}

.promo__cta-phone-icon {
  display: inline-flex;
}

.promo__footer-note {
  margin-top: 14px;
  text-align: center;
  font-size: 12px;
  color: #5b6b7f;
}

.promo__hint {
  font-size: 14px;
  opacity: 0.9;
  margin-bottom: 12px;
}

.phone-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.promo__phone {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-size: 36px;
  font-weight: 800;
  letter-spacing: 0.1em;
  margin: 8px 0;
  background: white;
  color: #2F84F8;
  padding: 16px 32px;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  }
}

.phone-icon {
  font-size: 28px;
}

.phone-number {
  background: #2F84F8;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 2px 4px rgba(31, 91, 255, 0.1);
}

.phone-hint {
  font-size: 10px;
  opacity: 0.8;
  margin-top: 8px;
  font-weight: 500;
}
.promo__lottie{
  margin-bottom: 30px;
}
.promo__actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.promo__btn {
  flex: 1;
  height: 48px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 15px;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-1px);
  }
}

.promo__btn_secondary {
  border: 2px solid #e2e8f0;
  background: white;
  color: #4a5568;

  &:hover {
    background: #f7fafc;
    border-color: #cbd5e0;
  }
}

.promo__btn_primary {
  background: linear-gradient(135deg, #1f5bff 0%, #4a7dff 100%);
  border: none;
  color: white;
  box-shadow: 0 4px 12px rgba(31, 91, 255, 0.3);

  &:hover {
    background: linear-gradient(135deg, #1748d6 0%, #3a6bff 100%);
    box-shadow: 0 6px 16px rgba(31, 91, 255, 0.4);
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}




</style>
